import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Qué aprenderé exactamente con este sistema?',
  answer: 'Aprenderás el funcionamiento del sistema de crédito en USA desde cero. Te enseñamos a leer tu reporte de las 3 agencias (Equifax, Experian y TransUnion), identificar errores comunes y aplicar las estrategias legales para eliminar registros negativos que afectan tu puntaje.'
}, {
  question: '¿Cuál es la diferencia entre esta guía y una agencia de reparación?',
  answer: 'Una agencia te cobraría entre $80 y $150 al mes por enviar cartas de disputa lentamente para mantenerte pagando. Nuestra guía te entrega todo ese conocimiento por un único pago. Te ahorramos miles de dólares en mensualidades y te damos las herramientas para que tú mismo tomes el control.'
}, {
  question: '¿Funciona si tengo ITIN o si acabo de llegar a USA?',
  answer: 'Totalmente. El sistema de crédito opera bajo las mismas reglas para números de Seguro Social y números de ITIN. Incluimos una sección específica sobre cómo empezar a construir historial sólido desde el primer día, facilitando tu camino hacia créditos de auto o vivienda.'
}, {
  question: '¿Es legal que yo mismo haga mi proceso de crédito?',
  answer: 'Sí, es 100% legal. La Ley de Informes Justos de Crédito (FCRA) te otorga el derecho de disputar cualquier información inexacta. Tu reporte es tu propiedad y tú tienes el poder legal de exigir que cada dato sea verificado o eliminado si es incorrecto.'
}, {
  question: '¿Después de pagar, cómo recibo el material?',
  answer: 'El acceso es inmediato y de por vida. Una vez procesado tu pago, verás una página de descarga y recibirás un correo electrónico con el Ebook y todos los bonos. Puedes leerlo en cualquier celular, computadora o tablet.'
}, {
  question: '¿Qué pasa si no me funciona o no estoy satisfecho?',
  answer: 'Estamos tan seguros de la calidad de nuestra información que ofrecemos una garantía de satisfacción. Nuestro objetivo es que la comunidad latina tenga las herramientas para prosperar. Si sientes que la guía no cumple lo prometido, solo escríbenos a nuestro soporte.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-white" data-id="element-25">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-26">
        <div className="text-center mb-16" data-id="element-27">
          <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-4" data-id="element-28">
            Preguntas Frecuentes
          </h2>
          <p className="text-lg text-slate-600" data-id="element-29">
            Resolvemos tus dudas para que tomes la mejor decisión.
          </p>
        </div>

        <div className="space-y-4" data-id="element-30">
          {faqs.map((faq, index) => <div key={index} className="border border-slate-200 rounded-xl overflow-hidden" data-id="element-31">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center bg-slate-50 hover:bg-slate-100 transition-colors" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-32">
                <span className="font-bold text-navy-900 pr-4" data-id="element-33">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-gold-500 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-34" />
              </button>

              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-35">
                <div className="p-6 bg-white text-slate-600 leading-relaxed border-t border-slate-100" data-id="element-36">
                  {faq.answer}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}